// extracted by mini-css-extract-plugin
module.exports = {"root":"ProfileNavigation_root__7Uzyh","content":"ProfileNavigation_content___cjq2"};